import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IAbstractView, IconName } from '@core/interfaces';
import { DialogPresenter } from './dialog.presenter';
import { IDialogComponent, IDialogPresenter } from './interfaces';
import { ButtonComponent } from '../button/button.component';
import { 
  DialogTypeEnum, DialogTypeEnumValues, 
  DialogTitleTypeEnum, DialogTitleTypeEnumValues,
  DialogTitleAlignEnum, DialogTitleAlignEnumValues
} from './enums';
import { IconComponent } from '../icon/icon.component';
import { ScrollContainerComponent } from '../scroll-container/scroll-container.component';

@Component({
  selector: 'app-juvo-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    IconComponent,
    ScrollContainerComponent
  ],
  providers: [DialogPresenter],
})
export class DialogComponent 
  extends IAbstractView<IDialogPresenter> 
  implements IDialogComponent {
  
  translations = this.presenter.translations;

  @Input() type: DialogTypeEnumValues = DialogTypeEnum.COMMON_SHORT;
  @Input() titleType: DialogTitleTypeEnumValues = DialogTitleTypeEnum.NEUTRAL;
  
  @Input() title: string = '';
  @Input() message?: string;
  
  @Input() titleAlign: DialogTitleAlignEnumValues = DialogTitleAlignEnum.CENTER;
  @Input() showTitle: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() showConfirm: boolean = true;
  @Input() showCancel: boolean = true;
  @Input() showThird: boolean = false;
  @Input() showCloseIcon: boolean = true;
  @Input() isStandaloneOverlay: boolean = true;
  @Input() showBottomBar: boolean = true;
  
  @Input() confirmText?: string;
  @Input() cancelText?: string;
  @Input() thirdText?: string;
  @Input() confirmIcon: IconName | null = null;
  @Input() confirmDisabled: boolean = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() thirdAction = new EventEmitter<void>();

  constructor(presenter: DialogPresenter) {
    super(presenter);
  }

  handleConfirm(): void {
    this.confirm.emit();
    this.presenter.closeModal('confirm');
  }

  handleCancel(): void {
    this.cancel.emit();
    this.presenter.closeModal('cancel');
  }

  handleThird(): void {
    this.thirdAction.emit();
    this.presenter.closeModal('third');
  }
}